import store from "../store";


export const awardListSelectors = {
	content: (state = store.getState()) => state.awards.content,
	search: (state = store.getState()) => state.awards.content.search,
	summary: (state = store.getState()) => state.awards.summary,
};
